import { useState } from 'react';
import { Tabs } from '../ui/Tabs';
type Width = 'telefoon' | 'computer';
const widths: Record<Width, string> = {
  telefoon: 'max-w-[375px]',
  computer: 'max-w-[640px]'
};
type Props = {
  html: string;
  subject: string;
  preheader: string;
  from: string;
};

/**
 * Zo ziet de lezer hem: eerst de regel in haar inbox, dan de mail zelf. De mail staat in een
 * iframe zonder scripts (`sandbox`), zodat zijn stijlen het beheer niet raken en andersom.
 */
export function NewsletterPreview({
  html,
  subject,
  preheader,
  from
}: Props) {
  const [width, setWidth] = useState<Width>('telefoon');
  return <div className="rounded-lg bg-white/60 p-4 ring-1 ring-line sm:p-5" data-id="element-3279" data-mp="3qvip3kgcf7y7">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2" data-id="element-3280" data-mp="3m4k447ketlom">
        <h2 className="text-[15px] font-medium text-ink" data-id="element-3281" data-mp="3m2haldk1taf5">Voorbeeld</h2>
        <Tabs label="Voorbeeld op" variant="pill" value={width} onChange={setWidth} tabs={[{
        key: 'telefoon',
        label: 'Telefoon'
      }, {
        key: 'computer',
        label: 'Computer'
      }]} data-id="element-3282" data-mp="2yders2dohbj2" />
      </div>

      <div className={`mx-auto ${widths[width]}`} data-id="element-3283" data-mp="2ywg4zb586tly">
        <div className="mb-3 rounded-md border border-line bg-white px-3 py-2.5" aria-label="Zo staat hij in de inbox" data-id="element-3284" data-mp="2yv51zdjltpvw">
          <p className="truncate text-[13px] font-medium text-ink" data-id="element-3285" data-mp="38n19ff7kyscs">{from}</p>
          <p className="truncate text-[13px] text-ink" data-id="element-3286" data-mp="38p5dbx5hbrd2">{subject || 'Zonder onderwerp'}</p>
          <p className="truncate text-[12px] text-muted" data-id="element-3287" data-mp="2bz4vki3j2b59">{preheader || 'De eerste regel van de mail'}</p>
        </div>
        <iframe title="Voorbeeld van de nieuwsbrief" srcDoc={html} sandbox="" className="h-[640px] w-full rounded-md border border-line bg-sand" data-id="element-3288" data-mp="2kxq89wmbivy4" />
      </div>
    </div>;
}